/**
 * Canonical product button — based on `.modal-button` (pill, brand cyan).
 * Variants: primary (save), secondary (cancel), danger.
 */
const VARIANT_CLASS = {
  primary: "modal-button modal-button-save",
  secondary: "modal-button modal-button-cancel",
  danger: "modal-button modal-button-danger",
};

const Button = ({
  variant = "primary",
  type = "button",
  disabled = false,
  className = "",
  children,
  ...rest
}) => {
  const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.primary;
  return (
    <button
      type={type}
      disabled={disabled}
      className={[variantClass, className].filter(Boolean).join(" ")}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
